var _g, _g2, _g3, _rect, _rect2, _rect3, _rect4, _g4, _g5, _g6, _g7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iiii_715_15214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z",
    fill: "url(#paint0_linear_715_15214)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.07227 4.63516C5.07227 3.7515 5.78861 3.03516 6.67227 3.03516H25.3277C26.2114 3.03516 26.9277 3.7515 26.9277 4.63516V28.3687C26.9277 29.2524 26.2114 29.9688 25.3277 29.9688H6.67227C5.78861 29.9688 5.07227 29.2524 5.07227 28.3687V4.63516Z",
    fill: "url(#paint1_radial_715_15214)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_715_15214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95117 5.53125C7.2608 5.53125 6.70117 6.09088 6.70117 6.78125V26.9727C6.70117 27.663 7.2608 28.2227 7.95117 28.2227H18.6423C18.8413 28.2227 19.032 28.1436 19.1727 28.003L24.3253 22.8504C24.4659 22.7098 24.5449 22.519 24.5449 22.3201V6.78125C24.5449 6.09088 23.9853 5.53125 23.2949 5.53125H7.95117Z",
    fill: "#CD7D52"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_715_15214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.31836 5.15625C7.62799 5.15625 7.06836 5.71588 7.06836 6.40625V26.5977C7.06836 27.288 7.62799 27.8477 8.31836 27.8477H19.0095C19.2084 27.8477 19.3992 27.7686 19.5399 27.628L24.6924 22.4754C24.8331 22.3348 24.9121 22.144 24.9121 21.9451V6.40625C24.9121 5.71588 24.3525 5.15625 23.6621 5.15625H8.31836Z",
    fill: "url(#paint2_linear_715_15214)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.03711,
    y: 12.0156,
    width: 13.9141,
    height: 0.976562,
    rx: 0.488281,
    fill: "#9B96A2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.03711,
    y: 15.0234,
    width: 13.9141,
    height: 0.976562,
    rx: 0.488281,
    fill: "#9B96A2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.03711,
    y: 18.0312,
    width: 13.9141,
    height: 0.976562,
    rx: 0.488281,
    fill: "#9B96A2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.03711,
    y: 21.0391,
    width: 8.96875,
    height: 0.976562,
    rx: 0.488281,
    fill: "#9B96A2"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_715_15214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6074 22.0303H24.6036C24.6036 22.2488 24.4814 22.3009 24.3623 22.3133H20.0561C19.5153 22.3133 19.077 22.7517 19.077 23.2924V27.5884C19.0477 27.7354 18.8582 27.8191 18.7595 27.8438L18.7559 27.8476H18.8281C19.0229 27.8476 19.2097 27.7702 19.3474 27.6325L24.3923 22.5875C24.53 22.4498 24.6074 22.263 24.6074 22.0683V22.0303Z",
    fill: "#D0C1E0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_715_15214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9119 21.9062H24.908C24.908 22.1295 24.7832 22.1827 24.6616 22.1953H20.2635C19.7112 22.1953 19.2635 22.643 19.2635 23.1953V27.5829C19.2336 27.733 19.04 27.8186 18.9393 27.8438L18.9355 27.8477H19.0093C19.2083 27.8477 19.399 27.7686 19.5397 27.628L24.6923 22.4754C24.8329 22.3347 24.9119 22.144 24.9119 21.9451V21.9062Z",
    fill: "url(#paint3_linear_715_15214)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_715_15214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7793 5.65625C10.7793 5.38011 11.0032 5.15625 11.2793 5.15625H20.4668V7.8125C20.4668 8.08864 20.2429 8.3125 19.9668 8.3125H11.2793C11.0032 8.3125 10.7793 8.08864 10.7793 7.8125V5.65625Z",
    fill: "#CABFD5"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ii_715_15214)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9902 1.98438C17.0694 1.98438 17.9474 2.84583 17.974 3.91861C17.9747 3.94621 17.997 3.96875 18.0246 3.96875H18.9668C20.0714 3.96875 20.9668 4.86417 20.9668 5.96875V7.53516C20.9668 7.81345 20.7412 8.03906 20.4629 8.03906H11.5332C11.2549 8.03906 11.0293 7.81345 11.0293 7.53516V5.96875C11.0293 4.86417 11.9247 3.96875 13.0293 3.96875H13.9559C13.9835 3.96875 14.0058 3.94621 14.0065 3.91861C14.0331 2.84583 14.9111 1.98438 15.9902 1.98438ZM15.9902 4.86719C16.4865 4.86719 16.8887 4.46494 16.8887 3.96875C16.8887 3.47256 16.4865 3.07031 15.9902 3.07031C15.494 3.07031 15.0918 3.47256 15.0918 3.96875C15.0918 4.46494 15.494 4.86719 15.9902 4.86719Z",
    fill: "url(#paint4_linear_715_15214)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iiii_715_15214",
    x: 4.72227,
    y: 2.78516,
    width: 22.4555,
    height: 27.4336,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.670588 0 0 0 0 0.376471 0 0 0 0 0.278431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15214"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.643137 0 0 0 0 0.329412 0 0 0 0 0.364706 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_15214",
    result: "effect2_innerShadow_715_15214"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.35,
    dy: 0.25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.225
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.760784 0 0 0 0 0.529412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_715_15214",
    result: "effect3_innerShadow_715_15214"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.05,
    dy: 0.05
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.815686 0 0 0 0 0.560784 0 0 0 0 0.396078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_715_15214",
    result: "effect4_innerShadow_715_15214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_715_15214",
    x: 6.20117,
    y: 5.03125,
    width: 18.8438,
    height: 23.6914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_715_15214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_715_15214",
    x: 6.91836,
    y: 5.00625,
    width: 18.1438,
    height: 22.9914,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.792157 0 0 0 0 0.721569 0 0 0 0 0.862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15214"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_15214",
    result: "effect2_innerShadow_715_15214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_715_15214",
    x: 18.5059,
    y: 21.7803,
    width: 6.35156,
    height: 6.31738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_715_15214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_715_15214",
    x: 18.9355,
    y: 21.9062,
    width: 6.12656,
    height: 6.04141,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.611765 0 0 0 0 0.705882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15214"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.075
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.878431 0 0 0 0 0.866667 0 0 0 0 0.890196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_15214",
    result: "effect2_innerShadow_715_15214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_715_15214",
    x: 10.3793,
    y: 4.75625,
    width: 10.4875,
    height: 3.95625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.2,
    result: "effect1_foregroundBlur_715_15214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_715_15214",
    x: 10.9293,
    y: 1.88437,
    width: 10.1375,
    height: 6.25469,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: -0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.556863 0 0 0 0 0.501961 0 0 0 0 0.572549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_715_15214"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.1,
    dy: 0.1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.65098 0 0 0 0 0.670588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_715_15214",
    result: "effect2_innerShadow_715_15214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_715_15214",
    x1: 16,
    y1: 3.03516,
    x2: 16,
    y2: 29.9688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8A874"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB925D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_715_15214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6855 5.3125) rotate(-90) scale(2.5 2.02864)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D79769"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D79769",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_715_15214",
    x1: 15.9902,
    y1: 5.15625,
    x2: 15.9902,
    y2: 27.8477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAE2F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DAEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_715_15214",
    x1: 19.3416,
    y1: 22.6875,
    x2: 21.6229,
    y2: 25.1562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6CDE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6BAD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_715_15214",
    x1: 18.7168,
    y1: 3.78125,
    x2: 15.6543,
    y2: 8.21875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#948A94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D8291"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/Clipboard.63c2a992b9d29d752ce511e00fe99d23.svg";
export { ForwardRef as ReactComponent };